import React from "react";
import ReportManager, {
  extractCurrencyName,
  groupByCurrency,
  linesColumns,
  linesTransformer,
} from "commons/components/ReportManager";
import { compose, map } from "ramda";

const filters = [
  { type: "filter", name: "products", key: "product_id" },
  { type: "filter", name: "facilities", key: "sales.facility_id" },
  {
    type: "filter",
    name: "users",
    key: "sales.user_id",
    extras: { optionLabel: "username" },
  },
  { type: "filter", name: "customers", key: "sales.customer_id" },
  { type: "filter", name: "categories", key: "products.category_id" },
];

const columns = [
  {
    name: "code",
    type: "text",
  },
  {
    name: "name",
    type: "text",
  },
  ...linesColumns,
  {
    name: "profit",
    type: "money",
  },
];

const byProductID = (record) => record.product_id + "";

export default function SalesByProduct() {
  return (
    <ReportManager
      filterByDate
      dateField="sales.date"
      url="sale-lines"
      title="salesByProduct"
      filters={filters}
      columns={columns}
      recordsFunc={compose(
        map(linesTransformer(byProductID, "product_id")),
        groupByCurrency
      )}
      titlesFunc={extractCurrencyName}
      totals={[
        "quantity",
        "returned",
        "actual",
        "subtotal",
        "discount",
        "total",
        "cost",
        "commission",
        "profit",
      ]}
    />
  );
}
